import axios from "axios";

import { BASE_URL } from "./apiBase";

// VAPID public key — set via REACT_APP_VAPID_PUBLIC_KEY env var
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || "";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export function isPushSupported() {
  return (
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window &&
    !!VAPID_PUBLIC_KEY
  );
}

export function getPushPermission() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function requestPushPermission() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.requestPermission();
}

export async function subscribeToPush() {
  if (!isPushSupported()) return null;

  const registration = await navigator.serviceWorker.ready;
  const existing = await registration.pushManager.getSubscription();
  if (existing) return existing;

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
  });

  return subscription;
}

export async function sendSubscriptionToServer(subscription) {
  if (!subscription) return;
  const keys = subscription.toJSON().keys;
  await axios.post(`${BASE_URL}/api/PushSubscriptions`, {
    endpoint: subscription.endpoint,
    p256dh: keys.p256dh,
    auth: keys.auth,
  });
}

export async function unsubscribeFromPush() {
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (subscription) {
    await subscription.unsubscribe();
    await axios
      .delete(`${BASE_URL}/api/PushSubscriptions`, {
        params: { endpoint: subscription.endpoint },
      })
      .catch(() => {});
  }
}

export async function initPushNotifications() {
  if (!isPushSupported()) return false;

  const permission = await requestPushPermission();
  if (permission !== "granted") return false;

  try {
    const subscription = await subscribeToPush();
    await sendSubscriptionToServer(subscription);
    return true;
  } catch {
    return false;
  }
}
